import getConfig from './getConfig';

export default (state) => getConfig(state).global;
